import { loadable } from 'react-lazily/loadable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TransactionFunctions, UserFunctions } from '../redux/actions/AppActionFunctions/AppActions';
const DeviceAssignmentView = loadable(() => import('../components/Device/Views/DeviceAssignmentView')).default;
const debug = process.env.REACT_APP_DEBUG && false;
const mapStateToProps = (state, ownProps) => {
    debug && console.log('DeviceAssignment own props', ownProps);
    return {
        contextCustomer: state.AppReducer.contextCustomer,
        user: state.AppReducer.user,
    };
};
const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        init: (cognitoUser, userGroupRoles) => {
            debug && console.log('DeviceAssignment Container requested init', ownProps);
        },
        userFunctions: bindActionCreators(UserFunctions, dispatch),
        transactionFunctions: bindActionCreators(TransactionFunctions, dispatch),
    };
};
/** @deprecated - No longer used */
export default connect(mapStateToProps, mapDispatchToProps)(DeviceAssignmentView);
